import { render } from "./VoipOrders.vue?vue&type=template&id=a558b76c"
import script from "./VoipOrders.vue?vue&type=script&lang=js"
export * from "./VoipOrders.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a558b76c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a558b76c', script)) {
    api.reload('a558b76c', script)
  }
  
  module.hot.accept("./VoipOrders.vue?vue&type=template&id=a558b76c", () => {
    api.rerender('a558b76c', render)
  })

}

script.__file = "src/views/services/modules/voip/pills/VoipOrders.vue"

export default script